export default __webpack_public_path__ + "static/media/permeable-blog-16.863d02bf.jpg";